import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import ApesterBlock from '~/components/Layout/Body/Blocks/ApesterBlock/ApesterBlock';
import CrowdSignalBlock from '~/components/Layout/Body/Blocks/CrowdSignalBlock/CrowdSignalBlock';
import DailyMotionBlock from '~/components/Layout/Body/Blocks/DailyMotionBlock/DailyMotionBlock';
import DividerBlock from '~/components/Layout/Body/Blocks/DividerBlock/DividerBlock';
import FacebookBlock from '~/components/Layout/Body/Blocks/FacebookBlock/FacebookBlock';
import FAQBlock from '~/components/Layout/Body/Blocks/FAQBlock/FAQBlock';
import GiphyBlock from '~/components/Layout/Body/Blocks/GiphyBlock/GiphyBlock';
import IframeEmbedBlock from '~/components/Layout/Body/Blocks/IframeEmbedBlock/IframeEmbedBlock';
import ImageBlock from '~/components/Layout/Body/Blocks/ImageBlock/ImageBlock';
import ImportedEmbeddedContentBlock from '~/components/Layout/Body/Blocks/ImportedEmbeddedContentBlock/ImportedEmbeddedContentBlock';
import ImportedTableBlock from '~/components/Layout/Body/Blocks/ImportedTableBlock/ImportedTableBlock';
import ImportedVideoBlock from '~/components/Layout/Body/Blocks/ImportedVideoBlock/ImportedVideoBlock';
import InlineTextBlock from '~/components/Layout/Body/Blocks/InlineTextBlock/InlineTextBlock';
import InstagramBlock from '~/components/Layout/Body/Blocks/InstagramBlock/InstagramBlock';
import JWBlock from '~/components/Layout/Body/Blocks/JWBlock/JWBlock';
import ListItemBlock from '~/components/Layout/Body/Blocks/ListItemBlock/ListItemBlock';
import LiveBlogBlock from '~/components/Layout/Body/Blocks/LiveBlogBlock/LiveBlogBlock';
import MMContentEmbedBlock from '~/components/Layout/Body/Blocks/MMContentEmbedBlock/MMContentEmbedBlock';
import PlaybuzzBlock from '~/components/Layout/Body/Blocks/PlaybuzzBlock/PlaybuzzBlock';
import QuoteBlock from '~/components/Layout/Body/Blocks/QuoteBlock/QuoteBlock';
import SoundcloudBlock from '~/components/Layout/Body/Blocks/SoundcloudBlock/SoundcloudBlock';
import StreamableBlock from '~/components/Layout/Body/Blocks/StreamableBlock/StreamableBlock';
import Table from '~/components/Layout/Body/Blocks/TableBlock/TableBlock';
import TableOfContentsBlock from '~/components/Layout/Body/Blocks/TableOfContentsBlock/TableOfContentsBlock';
import TwitterBlock from '~/components/Layout/Body/Blocks/TwitterBlock/TwitterBlock';
import VimeoBlock from '~/components/Layout/Body/Blocks/VimeoBlock/VimeoBlock';
import YoutubeBlock from '~/components/Layout/Body/Blocks/YoutubeBlock/YoutubeBlock';
import MMPlayerBlock from '~/components/Layout/Body/Blocks/MMPlayerBlock/MMPlayerBlock';
import VideoPlayer from '~/components/Shared/Video/VideoPlayer';
import { Logger } from '~/utilities/logger';
import { setStoreItem } from '~/utilities/Store';
import { LAST_LOADED } from '~/constants/LAST_LOADED';

const componentMap: Record<string, any> = {
  apester: ApesterBlock,
  'crowd-signal': CrowdSignalBlock,
  dailyMotion: DailyMotionBlock,
  divider: DividerBlock,
  facebook: FacebookBlock,
  faq: FAQBlock,
  giphy: GiphyBlock,
  iframeEmbed: IframeEmbedBlock,
  image: ImageBlock,
  'imported-embedded-content': ImportedEmbeddedContentBlock,
  'imported-table': ImportedTableBlock,
  'imported-video': ImportedVideoBlock,
  'inline-text': InlineTextBlock,
  instagram: InstagramBlock,
  mmPlayer: MMPlayerBlock,
  jw: JWBlock,
  'list-item': ListItemBlock,
  'live-blog': LiveBlogBlock,
  'mm-content-embed': MMContentEmbedBlock,
  playbuzz: PlaybuzzBlock,
  quote: QuoteBlock,
  streamable: StreamableBlock,
  soundcloud: SoundcloudBlock,
  table: Table,
  'table-of-contents': TableOfContentsBlock,
  twitter: TwitterBlock,
  youtube: YoutubeBlock,
  vimeo: VimeoBlock,
  'video-player': VideoPlayer,
};

type ContentBlockType = {
  item: {
    type: string;
    value: any;
  };
  index: number;
};

export default component$<ContentBlockType>(({ item, index }): JSX.Element => {
  const Component = componentMap[item.type] || null;
  setStoreItem(LAST_LOADED, item.type);

  if (!Component) {
    new Logger().error('Block type not found: ' + item.type);
    return <></>;
  }

  return <Component index={index} {...item.value} />;
});
